import React from 'react'
import { ArrowDownward, ArrowUpward } from '@mui/icons-material'

export function SortingArrows({
  isSorting,
  isAscending,
}: {
  isSorting: boolean
  isAscending: boolean
}) {
  if (!isSorting) return null
  return isAscending ? <ArrowUpward /> : <ArrowDownward />
}
